import './style/booking.css';
import React, { useEffect, useState } from 'react'
import axios from 'axios';

import Header from './header';
import Footer from './footer';

const UpdateBook = (props) => {
  
    const [uname, setName] = useState("");
    const [uemail, setEmail] = useState("");
    const [bdate, setbdate] = useState("");
    const [btime, setbtime] = useState("");
    const [rent, setrent] = useState("300");
    const [fdate, setfdate] = useState("");
    const [ftime, setftime] = useState("");
    const [msg, setMessage] = useState("");
    const [error, seterror] = useState("");
    const [status, setstatus] = useState(false);
    const [minsdate, setminsdate] = useState("");
    const [minedate, setminedate] = useState("");
    const [maxsdate, setmaxsdate] = useState("");
    const [maxedate, setmaxedate] = useState("");

    const onChangeName = (e) => setName(e.target.value);
    const onChangeEmail = (e) => setEmail(e.target.value);
    const onChangebDate = (e) => setbdate(e.target.value);
    const onChangebTime = (e) => setbtime(e.target.value);
    const onChangefDate = (e) => setfdate(e.target.value);
    const onChangefTime = (e) => setftime(e.target.value);

    const formatYmd = date => date.toISOString().slice(0, 10);
    // Example
        var mindate=formatYmd(new Date());      // 2020-05-06
    
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 2).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        if(mm===13) mm='01';
        var maxdate = yyyy + '-' + mm + '-' + dd;
    
        var mintime=("0" + today.getHours()).slice(-2);
        //  + ":" + ("0" + today.getMinutes()).slice(-2);
        // var minftime="00:00";
        const onBlurbDate = (e) =>{
            if(bdate!==""&& fdate==="")
            {
                setminedate(bdate.split());
                setmaxedate(maxdate);
            }
            else if(fdate!=="" && bdate!=="")
            {
                setminedate(bdate);
                setmaxedate(maxdate);
            }
        }
        const onBlureDate = (e) =>{
            if(fdate!=="" && bdate==="")
            {
                setminsdate(mindate);
                setmaxsdate(fdate.split());
            } 
            else if(fdate!=="" && bdate!=="")
            {
                setmaxsdate(fdate);
                setminsdate(mindate);
            }
        }
        const onBlurbtime = (e) =>{
            if((bdate===mindate) &&  parseInt(btime, 10)<mintime)
                 {
                    setstatus(false);
                    seterror("Enter Valid From Time");
                 }   
                 else{
                    setstatus(true);
                    seterror("");
                 }
                 if(ftime!=="" &&  (parseInt(btime, 10)>parseInt(ftime, 10)))
                 {
                    setstatus(false);
                    seterror("Enter Valid From Time");
                 }
        }
        const onBlurftime = (e) =>{
            if((bdate===fdate)&&(fdate===mindate)&& parseInt(btime, 10)<mintime || (parseInt(btime, 10)>parseInt(ftime, 10)))
                 {
                     setstatus(false);
                     seterror("Enter Valid From:To Time");
                 }   
                 else if((bdate===fdate)&&(parseInt(btime, 10)<mintime) && (fdate!==mindate))
                 {
                    {
                        setstatus(false);
                        seterror("Enter Valid From:To Time");
                    }  
                 }
                 else{
                    setstatus(true);
                    seterror("");
                 }
        }

        const onconfirm = (evt) => {
            // var cb=document.getElementById("accept");
            var bike= parseFloat(document.getElementById("bikes").value);
            var charge=parseInt(rent, 10); 
                if(bdate!==fdate)
                {
                    var days=0;
                    if(bdate[0].split('-')[1]!==fdate[0].split('-')[1])
                        {
                            switch(bdate.split('-')[1]){
                                case "01":
                                case "03":
                                case "05":
                                case "07":
                                case "08":
                                case "10":
                                case "12":days=31;break;
                                case "02":days=28;break;
                                default : days=30;break;
                            }
                            // switch(fdate.split('-')[1]){
                            //     case "01":
                            //     case "03":
                            //     case "05":
                            //     case "07":
                            //     case "08":
                            //     case "10":
                            //     case "12":days=days+31;break;
                            //     case "02":days=days+28;break;
                            //     default : days=days+30;break;
                            // }
                            days=days-parseInt(bdate[0].split('-')[2],10);
                            days=days+parseInt(fdate[0].split('-')[2],10);
                        }
                    else days=parseInt(fdate[0].split('-')[2],10)-parseInt(bdate[0].split('-')[2],10);
                    charge=charge+300+(720*days)+(bike*(parseInt(ftime,10)+(24-parseInt(btime,10))));
                    //30rs per hour cost and 720rs per day cost
                }
               else charge=charge+(bike*(parseInt(ftime,10)-parseInt(btime,10)));
               charge=charge*(parseFloat(document.getElementById("cities").value));
               //50rs per hour cost
               setrent(charge);
            }

    const handleSubmit = (evt) => {
        // if(String(bdate).substring(8,)===String(fdate).substring(8,))
        //     minftime=("0" + today.getHours()).slice(-2)   + ":" + ("0" + today.getMinutes()).slice(-2);
        evt.preventDefault();
        if(status===true)
        {
            console.log(`Form submitted:`);
        console.log(`NAME: ${uname}`);
        console.log(`EMAIL: ${uemail}`);
        const info = {
            empname: uname,
            empemail: uemail,
            pdate: bdate[0],
            ptime: btime,
            ddate: fdate[0],
            dtime: ftime,
            brent: rent
        }
        console.log(info);
        axios.put('https://akshatngupta-bike-rental.herokuapp.com/booking/update', info)
            .then(res => {
                console.log(res.data)
                setMessage('BOOKING UPDATED')
            })
            .catch((error) => {
                // console.log("ERROR AYA");
                console.log(error);
            });

        setbdate('')
        setbtime('')
        setfdate('')
        setftime('')
        }
        else
        seterror("PLEASE INPUT VALID FROM:TO TIME!")
	}

    //Similar to componentDidMount and componentDidUpdate
    useEffect(() => {
        //"/updateprofile/:emailid"
        // window.location.pathname.split()
        let emailid = sessionStorage.getItem('email')
        console.log(emailid)
        if (emailid == null)
        {
            emailid = props.email
        }
        axios.get('https://akshatngupta-bike-rental.herokuapp.com/booking/search/' + emailid)
            .then(response => {
                console.log(response.data)
                const { name, email, pdate, ptime, ddate,dtime,crent } = response.data[0]
                if(false)
                {
                    //did this to remove warnings
                    console.log(pdate+""+ptime+""+ddate+""+dtime);
                }
                console.log(response.data[0]._id)
                
                var startd = response.data[0].sdate.split();
                var startt = response.data[0].stime.split(':')[0];
                var endd = response.data[0].edate.split();
                var endt = response.data[0].etime.split(':')[0];
                var brent =response.data[0].rent;
                setName(name)
                setEmail(email)
                setbdate(startd)
                setbtime(startt)
                setrent(brent)
                setfdate(endd)
                setftime(endt)

            })
            .catch((error) => {
                console.log(error);
            })
    }, [])
    
  return (
    <div id={'in'}>
    <Header />
    <div className='main'>
        <div className='container'>
            <div className='bike-container'>
                <div className='bg-color'>
                    <div className='bike'>
                        <img src={require(`../assets/duke.png`)} alt='' />
                    </div>
					<form onSubmit={handleSubmit}>
                        <div className="form2">
                            <b>
						    <h4>Update Booking</h4></b>
                            <p><b style={{ color: "brown" }}> {msg}</b></p>
                            <label className="labels">Location  :</label>
							{/* <input type="text" className="form-control" value={uname} onChange={onChangeName} placeholder="Enter Name" required /> */}
							<select name="location" id="cities">
                                <option value="1.5">Delhi</option>
                                <option value="2.8">Mumbai</option>
                                <option value="1.2">Kolkata</option>
                                <option value="2.3">Banglore</option>
                                <option value="2.5">Pune</option>
                                <option value="2.0">Chennai</option>
                            </select>
                            <label className="labels">Bikes  :</label>
							{/* <input type="text" className="form-control" value={uname} onChange={onChangeName} placeholder="Enter Name" required /> */}
							<select id="bikes">
                                <option value="21">Yamaha FZ</option>
                                <option value="28">Honda CB Hornet 160</option>
                                <option value="33">TVS Apache RTR 180</option>
                                <option value="30">Yamaha Fazer 25</option>
                                <option value="15">Honda Activa 5G</option>
                                <option value="18">Honda Dio</option>
                                <option value="15">Honda Aviator</option>
                                <option value="45">Royal Enfield Himalayan</option>
                                <option value="57">Jawa Standard</option>
                                <option value="60">KTM RC 390</option>
                                <option value="92">BMW G310R</option>
                            </select>
                            <br/>
                            <label className="labels">Name</label>
							<input type="text" className="form-control" value={uname} onChange={onChangeName} placeholder={uname}  readOnly />
							<label>Email</label>
							<input type="email" className="form-control" value={uemail} onChange={onChangeEmail} placeholder={uemail} readOnly/>
                            <label>Date-Of-PickUp</label>
							<input type="date" className="form-control" min={mindate} max={maxdate} value={bdate} onChange={onChangebDate} required/>
							<label>Date-Of-DropOff</label>
							<input type="date" className="form-control" min={mindate} max={maxdate} value={fdate} onChange={onChangefDate} required/>
                            <div>
                            <label className="align1">From:Time</label>
                            <label className="align1">To:Time</label>
                            </div>
                            <div >
                            <input type="number" className="form-control1"  min="00" max="24" value={btime} onChange={onChangebTime} onBlur={onBlurbtime} placeholder="HH" required />
                            <input type="number" className="form-control2"  min="00" max="24" value={ftime} onChange={onChangefTime} onBlur={onBlurftime} placeholder="HH" required/>
                            </div>	
                            <div><b className="text-danger" style={{ color: "red" }}>{error}</b></div>
                            <br/>
                            <label >Your Charge:</label>
                            <input type="number" className=" form-control2 " value={rent} readOnly />
                            <br/>
                            <input type="checkbox" id="accept" onChange={onconfirm} required/> I confirm to book my ride
                            <br/>
                            <button type="submit"  className="Button3" value="REGISTER">Update</button>
                        
                        </div>
					</form>
				</div>
            </div>
        </div>
    </div>
    <br/>
    <Footer />
    </div>
  );
};
export default UpdateBook;